﻿import { defineStore } from 'pinia'
import { useHostNameStore } from '@/stores/useHostNameStore'
import type { AppConfiguration } from '@/types'
import i18n from '@/locales/dictionary'

export const useAppConfigurationStore = defineStore('appconfiguration', {
    state: () => ({
        configuration: getConfiguration(),
        isTidTilTur() {
            return getConfiguration().id.includes('tidtiltur.dk')
        },
        isAffaldsindsamlingen() {
            return getConfiguration().id.includes('affaldsindsamlingen.dk')
        },
        isLocalDepartment() {
            return getConfiguration().id.includes('lokaleevents.dn.dk')
        },

        isNaturensUge() {
            return getConfiguration().id.includes('naturensuge.dk')
        },
        isDn() {
            return getConfiguration().id === 'dn'
        }
        , isLocalhost() {
            return getConfiguration().id === 'localhost'
        },
        isDevelopment() {
            return getConfiguration().environment === 'development'
        },
        isStaging() {
            return getConfiguration().environment === 'staging'
        },
        isProduction() {
            return getConfiguration().environment === 'production'
        },
    }),

})

function getConfiguration() {
    const hostNameStore = useHostNameStore()


    console.log('Host name:', hostNameStore.hostname)
    // default configuration
    var configuration: AppConfiguration = {
        id: hostNameStore.hostname,
        environment: hostNameStore.environment,
        showPreview: false,
        showProgressbar: true,
        logoUrl: '/images/logo/dn-logo.svg',
        showNewsletter: false,
        showImages: true,
        externalEventLinkUrl: "",
        header: {
            showHome: true,
            showEvents: true,
            showHelp: true,
            helpLink: 'https://aktiv.dn.dk/sadan-gor-vi/ture-og-arrangementer/annoncering-af-ture/',

            showCreateEvent: false,
            showMyEvents: true,
            showOrganizer: true,
            showOverview: true,
            logoLinkTo: 'events-search'
        },
        pages: {
            organizer: { showCreateOrganizer: true },
            createEvent: { showHeader: true },
            frontpage:{ showEvents:true, showLogin:false}
        },
        paths: {
            home: '/min-side',
            myEvents: '/min-side/mine-arrangementer',
            eventCreated: '/min-side/mine-arrangementer/kvittering'
        }
    } as AppConfiguration

    if (configuration.id.includes('events.dn.dk') || configuration.id.includes('lokaleevents.dn.dk') || configuration.id.includes('localhost')) {
        i18n.global.locale = "dn";
    }

    
      if ( configuration.id.includes('localhost')) {
        i18n.global.locale = "naturensuge";
    }

    // Tid til tur configuration

    if (configuration.id.includes('tidtiltur.dk')) {
        i18n.global.locale = "tidtiltur";

        configuration.showPreview = false
        configuration.showImages = false
        configuration.showNewsletter = false,
            configuration.externalEventLinkUrl = "https://tidtiltur.dk/tur/",
            configuration.header = {
                showHome: true,
                showEvents: false,
                showHelp: true,
                helpLink: 'https://tidtiltur.dk/hjaelp-til-turmodul',

                showCreateEvent: false,
                showMyEvents: true,
                showOverview: true,
                showOrganizer: false,
                logoLinkTo: 'home'
            }
        configuration.pages.organizer.showCreateOrganizer = false;
        configuration.pages.frontpage = { showEvents:false, showLogin:true}
    
        configuration.paths = {
            home: '/min-side',
            myEvents: '/min-side/mine-ture',
            eventCreated: '/min-side/mine-ture/kvittering'

        }
        configuration.logoUrl = '/images/logo/ttt-logo.svg'
    } else

        if (configuration.id.includes('affaldsindsamlingen.dk')) {
            i18n.global.locale = "affaldsindsamlingen";

            configuration.showPreview = false
            configuration.showProgressbar = false
            configuration.showImages = false
            configuration.showNewsletter = false,
                configuration.externalEventLinkUrl = "",
                configuration.header = {
                    showHome: true,
                    showEvents: false,
                    showHelp: true,
                    
                    helpLink: 'https://www.affaldsindsamlingen.dk/hjaelp-til-oprettelse/',
                    showCreateEvent: false,
                    showMyEvents: true,
                    showOverview: true,
                    showOrganizer: true,
                    logoLinkTo: 'home'
                }
            configuration.paths = {
                home: '/min-side',
                myEvents: '/min-side/mine-indsamlinger',
                eventCreated: '/min-side/mine-indsamlinger/kvittering'
            }
            configuration.pages.organizer.showCreateOrganizer = false;
            configuration.pages.createEvent.showHeader = false;

            configuration.logoUrl = '/images/logo/ai-logo.png'

        } else
         if (configuration.id.includes('naturensuge.dk') || configuration.id.includes('localhost')) {
            i18n.global.locale = "naturensuge";

            configuration.showPreview = false
            configuration.showProgressbar = false
            configuration.showImages = true
            configuration.showNewsletter = false,
                configuration.externalEventLinkUrl = "",
                configuration.header = {
                    showHome: true,
                    showEvents: false,
                    showHelp: true,
                    
                    helpLink: 'https://www.naturensuge.dk/arrangoerer/#FAQ',
                    showCreateEvent: false,
                    showMyEvents: true,
                    showOverview: true,
                    showOrganizer: true,
                    logoLinkTo: 'home'
                }
            configuration.paths = {
                home: '/min-side',
                myEvents: '/min-side/mine-arrangementer',
                eventCreated: '/min-side/mine-arrangementer/kvittering'
            }
            configuration.pages.organizer.showCreateOrganizer = false;
            configuration.pages.createEvent.showHeader = false;

             configuration.pages.frontpage = { showEvents:false, showLogin:true}
            configuration.logoUrl = '/images/logo/naturensuge-logo.png'

        }

        // Localhost configuration
        else
            if (configuration.id === 'localhost') {
                //  i18n.global.locale = "tidtiltur";

                configuration.showPreview = false
                configuration.showImages = true
                configuration.showNewsletter = false
                configuration.externalEventLinkUrl = "",
                    configuration.header = {
                        showHome: true,
                        showEvents: false,
                        showHelp: true,
                        helpLink: 'https://aktiv.dn.dk/sadan-gor-vi/ture-og-arrangementer/annoncering-af-ture/',
                        showCreateEvent: true,
                        showMyEvents: true,
                        showOverview: false,
                        showOrganizer: true,

                        logoLinkTo: 'home'
                    }
                configuration.paths = {
                    home: '/min-side',
                    myEvents: '/min-side/mine-arrangementer',
                    eventCreated: '/min-side/mine-arrangementer/kvittering'
                }
                configuration.logoUrl = '/images/logo/ttt-logo.svg'
                configuration.pages.frontpage = { showEvents:false, showLogin:true}


            }

    return configuration
}
